import React from "react";

import Page from '../LandingPage';
import Meta from "../../components/Meta";

const descImg = 'https://res.cloudinary.com/cerebriti/image/upload/v1622014939/LANDING%20VACACIONES%20IMAGENES/juegos_verano_Academons_animado.gif'
const poster = 'https://res.cloudinary.com/cerebriti/image/upload/v1622802772/DESCARGAS%20PDF%20CUADERNOS%20VACACIONES/CUADERNOS%20LANDING/portada_cuaderno_3.png';

const ThirdYear = () => {
    return <>
        <Meta
            keywords={'Cuaderno de vacaciones gratis 3 Primaria'}
            title={'Cuaderno de vacaciones gratis para 3º de Primaria | Academons'}
            desc={'Descarga gratis este cuaderno de vacaciones para repasar 3º de Primaria en verano. Un cuadernillo en PDF con más de 50 fichas de tercero de Primaria'}
            h1={'Cuaderno de vacaciones gratis para 3º de Primaria'}
        />
        <Page
            preTitle={'ACTIVIDADES DE REPASO PARA NIÑOS DE 9 AÑOS'}
            title={'¡Descarga gratis tu cuaderno de vacaciones para 3º Primaria!'}
            text={"Estás a un paso de conseguir tu cuaderno de vacaciones de 3º Primaria con ejercicios de refuerzo de todas las materias, para que tus hijos se diviertan mientras repasan este verano. ¡Déjanos una dirección de correo y te lo enviamos gratis! "}
            form={[
                {
                    name: 'email',
                    label: 'Escribe tu email',
                    type: 'email'
                },
                {
                    name: 'schoolYear',
                    type: 'hidden',
                    value: 'Cuaderno de 3º Primaria'
                },
            ]}
            leagal={'Al introducir tus datos aceptas darte de alta en nuestro boletín educativo, en el que te informaremos de más descargables y otras noticias de Academons.'}
            poster={poster}
            titleSecondary={'¿Qué encontrarás en este cuaderno de verano?'}
            points={[
                <>PDF descargable con más de <b>50 fichas imprimibles diseñadas por docentes.</b></>,
                <>Ejercicios para repasar <b>Matemáticas, Lengua, Ciencias, Inglés y Sociales de 3º Primaria</b></>,
                <><b>Acceso gratuito a nuestra App</b> con más de <b>20.000 actividades</b> educativas</>
            ]}
            descImg={descImg}
        />
    </>
}

export default ThirdYear;